/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import roundScreenStyle from './style';

export default function DscRoundScreen({title, isNumbered, rounds}) {
	let style = roundScreenStyle();

	return (
		<div style={style.outerStyle()}>
			<h1 style={style.titleStyle()}>{title}</h1>
			{rounds ? (
				rounds.map((round, i) => {
					return <Round round={round} i={i} />;
				})
			) : (
				<></>
			)}
		</div>
	);

	function Round({round, i}) {
		let entries = round.length + (isNumbered ? 1 : 0);

		return (
			<div style={style.decRoundContainerStyle()}>
				{round ? (
					round.map((entry, j) => {
						let isNumber = isNumbered ? (j === 0 ? true : false) : false;
						return (
							<>
								{isNumber ? (
									<div className={style.descRoundCollumnClasses({entries: entries})} style={style.decRoundCollumnStyle({entries: entries, isNumber: true, hasNumber: isNumbered})}>
										<p style={style.descGenericText({isNumber: true})}>{i + 1}</p>
									</div>
								) : (
									<></>
								)}
								<div className={style.descRoundCollumnClasses({entries: entries})} style={style.decRoundCollumnStyle({entries: entries, isNumber: false, hasNumber: isNumbered})}>
									<p style={style.descGenericText({isNumber: false, isHeader: true})}>{entry.header}</p>
									<p style={style.descGenericText({isNumber: false, isHeader: false})}>{entry.value}</p>
								</div>
							</>
						);
					})
				) : (
					<></>
				)}
			</div>
		);
	}
}
